import { CLASSIFICATION_NOTICES } from "@/modules/cardClassificationRegistry";

const NOTICE_MAP = {
  distributor_users: CLASSIFICATION_NOTICES.distributorUsers,
  buyer_catalog: CLASSIFICATION_NOTICES.buyerCatalog,
  buyer_internal: CLASSIFICATION_NOTICES.buyerInternal,
  fiscal_vs_operational: CLASSIFICATION_NOTICES.fiscalVsOperational,
};

/**
 * Aviso aclaratorio PR-C — separación distribuidor / comprador / clientes.
 * @param {{ variant: keyof NOTICE_MAP, className?: string }} props
 */
export default function CommercialClassificationNotice({ variant, className = "" }) {
  const text = NOTICE_MAP[variant];
  if (!text) return null;
  return (
    <div
      className={`rounded-sm border border-slate-200 bg-slate-50/90 px-4 py-3 text-xs text-slate-700 leading-relaxed ${className}`}
      data-testid={`classification-notice-${variant}`}
    >
      {text}
    </div>
  );
}
